module.exports = __webpack_public_path__ + "img/main-bg.611f022c.png";